import { useState, useEffect } from "react";
import BrokerTable from "./brokerTable";
import BrokerModal from "./brokerModal";
import useApi from "../../../hooks/apiService";
import { useTranslation } from "react-i18next";
import NoDataTables from "../../../components/noDataTables";

export default function Brokers() {
  const { t } = useTranslation();
  const { fetchData, postData, updateData, deleteData } = useApi();
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingBroker, setEditingBroker] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState("");

  const fetchBrokers = async () => {
    try {
      const res = await fetchData("/broker-connection-settings");
      setTableData(res.data || []);
    } catch (err) {
      console.error("Erro ao buscar brokers", err);
    }
  };

  useEffect(() => {
    fetchBrokers();
  }, []);

  const handleShow = () => {
    setIsEdit(false);
    setEditingBroker(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEdit(false);
    setEditingBroker(null);
    setError("");
  };

  const handleDataAdded = () => {
    fetchBrokers();
  };

  const handleDataDeleted = (deletedId) => {
    setTableData((prev) => prev.filter((item) => item.id !== deletedId));
  };

  const handleDataEdited = () => {
    fetchBrokers();
  };

  const handleOpenEdit = (broker) => {
    setIsEdit(true);
    setEditingBroker(broker);
    setShow(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/broker-connection-settings/${id}`);
      handleDataDeleted(id);
    } catch (err) {
      console.error("Erro ao deletar broker", err);
      setError(t("Erro ao deletar broker"));
    }
  };

  return (
    <>
      <br />
      {tableData.length > 0 ? (
        <BrokerTable
          data={tableData}
          onShowModal={handleShow}
          onEditBroker={handleOpenEdit}
          onDeleteBroker={handleDelete}
          deleteData={deleteData}
        />
      ) : (
        <NoDataTables
          message={t("Nenhum broker cadastrado")}
          addItem={handleShow}
        />
      )}

      <BrokerModal
        show={show}
        onHide={handleClose}
        isEdit={isEdit}
        editingBroker={editingBroker}
        onDataAdded={handleDataAdded}
        onDataEdited={handleDataEdited}
        postData={postData}
        updateData={updateData}
        error={error}
        setError={setError}
      />
    </>
  );
}
